import * as React from "react";

export function Col({ children }: React.PropsWithChildren) {
    return <div className="mc-col">{children}</div>;
}